export default __webpack_public_path__ + "static/media/sanitizer2.f8565a81.jpg";